function updateSlidesBasedOnWidth() {
  var splideList = document.querySelector('.feature-column-section .splide__list');
  
  if (window.innerWidth < 768) {
    splideList.innerHTML = splideList.dataset.mobSlides;
  } else {
    splideList.innerHTML = splideList.dataset.deskSlides;
  }
}

document.addEventListener('DOMContentLoaded', function () {
  
  const buttons = document.querySelectorAll('nav ul[x-ref="navigation"] li button');
  buttons.forEach(function(button) {
      button.addEventListener('click', function() {
          document.body.classList.toggle('popup');
      });
  });
  
  document.addEventListener('click', function(event) {
      if (
          !event.target.closest('nav ul[x-ref="navigation"] li button') &&
          !event.target.closest('.no-js-focus-container') && 
          document.body.classList.contains('popup')
      ) {
          document.body.classList.remove('popup');
      }
  });

  if(window.location.pathname === "/"){

    var slider = $('.focus_carousel .feature-slider');
    var title = $('.upper_slide_title');
      $(window).on('load', function() {
        function applyTransitionEnd() {
            setTimeout(function() {
                $('body').addClass('transition_end');
                $('.resized_image').addClass('transition_end');
                $('.focus_carousel').addClass('transition_end');
                $('.site-header').addClass('transition_end');
                // $('.announcement_bar').addClass('transition_end');
            }, 1000);
        }
        function applyTransitionStart() {
            $('.resized_image').addClass('transition_start');
        }
    });

    slider.slick({
        speed: 300,
        slidesToScroll: 1,
        slidesToShow: 3,
        centerMode: true,
        touchThreshold: 80,
        infinite: true,
        arrows: (slider.attr('data-arrows') === 'true'),
        dots: (slider.attr('data-dots') === 'true'),
        responsive: [
          {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    dots: false
                }
            }
        ]
    });

    function isMacSafari() {
      return (
        navigator.platform.toUpperCase().indexOf('MAC') >= 0 &&
        /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
      );
    }

    
    if (isMacSafari()) {
      $(window).on('load', function () {
        if (window.innerWidth > 768) {
          let hasPrimed = false;
    
          slider.on('touchstart', function () {
            if (!hasPrimed) {
              slider.slick('slickNext');
              slider.slick('slickPrev');
              slider.slick('setPosition');
              hasPrimed = true;
            }
          });
        }
      });
    }
    
  function updateSlideFooterClasses(slick, currentSlide) {
    var active_slide = currentSlide;
    $('.slide_footer').each(function() {
        $(this).removeClass('slick-current slick-active');
    });
    $('.upr_slide_item').each(function() {
        $(this).removeClass('slick-current slick-active');
    });
    
    $('.slide_footer[data-slick-index="'+active_slide+'"]').addClass('slick-current slick-active');
    $('.upr_slide_item[data-slick-index="'+active_slide+'"]').addClass('slick-current slick-active');
  }
  
  $('.focus_carousel .feature-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      updateSlideFooterClasses(slick, nextSlide);
  });
  
  $('.focus_carousel .feature-slider').on('afterChange', function(event, slick, currentSlide) {
      updateSlideFooterClasses(slick, currentSlide);
  });

 
    var video = document.querySelector('.home_clinical_video video');
    var ask_video = document.querySelector('.home_ask video');
    var result_video = document.querySelector('.home_result_video video');
    const screenWidth = window.innerWidth;
   
    function handleVideoInView(Video) {
        const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          // console.log('Video visibility: ', entry.isIntersecting);
            if (entry.isIntersecting) {
                if (Video) {
                    Video.currentTime = 0;
                    Video.play();
                }
            } else {
                if (Video && !Video.paused) {
                    // Video.pause();
                    // Video.currentTime = 0; 
                }
            }
        });
      }, { threshold: 0.5 }); 
      if (Video) {
          observer.observe(Video);
      }
    }
    
    function updateVideoElements() {
      if (screenWidth <= 767) {
          const deskHiddenElement = document.querySelector('.home_clinical_video .desk_hidden');
          if (deskHiddenElement) {
              video = deskHiddenElement.querySelector('video');
          }
  
          const askDeskHiddenElement = document.querySelector('.home_ask .desk_hidden');
          if (askDeskHiddenElement) {
              ask_video = askDeskHiddenElement.querySelector('video');
          }
  
          const resultDeskHiddenElement = document.querySelector('.home_result_video .desk_hidden');
          if (resultDeskHiddenElement) {
              result_video = resultDeskHiddenElement.querySelector('video');
          }
      }
  
      if (video) {
          video.removeAttribute('autoplay');
          video.removeAttribute('loop');
      }
      if (ask_video) {
          ask_video.removeAttribute('autoplay');
          ask_video.removeAttribute('loop');
      }
      if (result_video) {
          result_video.removeAttribute('autoplay');
          result_video.removeAttribute('loop');
      }
  
    }

    function resetVideo() {
        if (video) {
            video.pause();
            video.currentTime = 0;
        }
        if (ask_video) {
            ask_video.pause();
            ask_video.currentTime = 0;
        }
      if (result_video) {
            result_video.pause();
            result_video.currentTime = 0;
        }
    }
    
    function handlePopupAndVideo() {
        const popup = document.querySelector('.needsclick.kl-private-reset-css-Xuajs1');
        
        if (popup) {
            if (video) video.pause();
            if (ask_video) ask_video.pause();
        } else {
            if (video) video.play();
            if (ask_video) ask_video.play();
            if (result_video) result_video.play();
        }
    }
    
    function initialize() {
        updateVideoElements();
        handlePopupAndVideo();
        handleVideoInView(video);
        handleVideoInView(ask_video);
        handleVideoInView(result_video);
      
    }
    
    window.addEventListener('resize', function() {
        updateVideoElements();
        handlePopupAndVideo(); 
    
    });

    initialize();
    
    if (video) {
        video.addEventListener('ended', function() {
            video.pause();
        });
        video.addEventListener('pause', function() {
            if (video.currentTime !== video.duration) {
                resetVideo();
            }
        });
    }
    
    if (ask_video) {
        ask_video.addEventListener('ended', function() {
            ask_video.pause();
        });
        ask_video.addEventListener('pause', function() {
            if (ask_video.currentTime !== ask_video.duration) {
                resetVideo();
            }
        });
    }

    if (result_video) {
        result_video.addEventListener('ended', function() {
            result_video.pause();
        });
        result_video.addEventListener('pause', function() {
            if (result_video.currentTime !== result_video.duration) {
                resetVideo();
            }
        });
    }
  }
  if (window.location.href.indexOf("/products") !== -1) {
    const videoThumbnails = document.querySelectorAll('.media-thumbnail.media-video');
    videoThumbnails.forEach(function(thumbnail) {
        thumbnail.addEventListener('click', function() {
            const videoElement = document.querySelector('.feature-media-item video');
            if (videoElement) {
                videoElement.play();
            }
        });
    });
  
    window.addEventListener('scroll', function() {
      if(document.querySelector('.fix-center-image-section.pdp_video')){
        var rightHighlight = document.querySelector('.right_highlight');
        var leftHighlight = document.querySelector('.left_highlight');
        var title = document.querySelector('.fix-center-image-section.pdp_video .font-heading');
        var rightHighlightTop = title.getBoundingClientRect().top;
        if (rightHighlightTop < 0) {
          rightHighlight.style.opacity = '0';
          rightHighlight.style.transition = 'opacity 0.5s';
          leftHighlight.style.opacity = '1';
          leftHighlight.style.transition = 'opacity 0.5s';
        } else {
          rightHighlight.style.opacity = '1';
          leftHighlight.style.opacity = '0';
          rightHighlight.style.transition = 'opacity 0.5s';
          leftHighlight.style.transition = 'opacity 0.5s';
        }
      }
    });

    document.querySelectorAll('.feature-tab-heading').forEach(function(tab) {
      tab.addEventListener('click', function() {
        var dataVal = tab.getAttribute('data-value');
        var section = tab.closest('.feature-tabs-section');
    
        section.querySelectorAll('.feature-tab-heading').forEach(function(otherTab) {
          otherTab.classList.remove('active');
        });
    
        tab.classList.add('active');
    
        section.querySelectorAll('.feature-tab-content').forEach(function(content) {
          content.style.display = 'none';
        });
    
        var activeContent = section.querySelector('.feature-tab-content[data-value="' + dataVal + '"]');
        if (activeContent) {
          activeContent.style.display = 'block';
        }
      });
    });

    var slider = $('.testimonials .slick-slider');
    $('.testimonials .slick-slider').slick({
        speed: 300,
        slidesToScroll: 1,
        slidesToShow: 2,
        centerPadding: "10%",
        draggable: true,
        swipe: true,
        touchThreshold: 80,
        touchMove: true,
        swipeToSlide: true,
        autoplay: (slider.attr('data-autostart') === 'true'),  
        infinite: true,
        arrows: (slider.attr('data-arrows') === 'true'), 
        dots: (slider.attr('data-dots') === 'true'),
        responsive: [
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 1,
            centerPadding: "20%"
          }
        }
      ]
    });

    $('.testimonials .slick-slider').slickLightbox({
        src: 'src',
        itemSelector: '.js-gallery-popup img',
        navigateByKeyboard  : true,
        background: 'rgba(0, 0, 0, .7)'
    });
  }

});
